import BreadcrumbsModule from '@oarepo/vue-breadcrumbs'

export default ({ app, Vue }) => {
  Vue.use(BreadcrumbsModule, {
    store: app.store
  })
}
